// Import all images
import addCustomerImg from '../assets/icons/addCustomer.png';
import modelsNotFoundImg from '../assets/icons/modelsNotFound.png';
import addModelImg from '../assets/icons/addModel.png';
import createCustomerImg from '../assets/icons/createCustomer.png';
import addGroupTypeImg from '../assets/icons/addGroupType.png';
import addProductImg from '../assets/icons/addProduct.png';
import productCardImg from '../assets/icons/productCard.png';
import greenPlanesImg from '../assets/icons/greenPlanes.png';
import codatImg from '../assets/icons/codat.png';
import salesforceImg from '../assets/icons/salesforce.png';
import somethingWentWrongImg from '../assets/icons/somethingWentWrong.png';
import emptyGraphImg from '../assets/icons/emptyGraph.png';
import deleteItemImg from '../assets/icons/deleteItem.png';
import createContractImg from '../assets/icons/createContract.png';
import emptyDataImg from '../assets/icons/emptyData.png';
import addModelBlueImg from '../assets/icons/addModelBlue.png';
import addContractBlueImg from '../assets/icons/addContractBlue.png';
import emptyGraphsImg from '../assets/icons/emptyGraphs.png';
import wipImg from '../assets/icons/wip.png';
import addUsageReportImg from '../assets/icons/addUsageReport.png';
import successImg from '../assets/icons/success.png';
import authorizationImg from '../assets/icons/authorization.png';
import noInternetImg from '../assets/icons/noInternet.png';
import noLateCustomersImg from '../assets/icons/noLateCustomers.png';
import activeContractImg from '../assets/icons/activeContract.png';
import cantDeleteImg from '../assets/icons/cantDelete.png';
import exportCSVImg from '../assets/icons/exportCSV.png';
import quickBooksImg from '../assets/icons/qb.png';
import blankPricingModelCardImg from '../assets/icons/blankPricingModelCard.png';
import outOfSyncImg from '../assets/icons/outOfSync.png';
import connectedImg from '../assets/icons/connected.jpg';
import whiteRefreshImg from '../assets/icons/whiteRefresh.png';
import welcomeImg from '../assets/icons/welcome.png';
import emptyBoxImg from '../assets/icons/emptyBox.png';
import netsuiteImg from '../assets/icons/netsuite.png';
import loginImg from '../assets/icons/login.png';
import usageProductCardImg from '../assets/icons/usageProductCard.png';
import defaultProductCardImg from '../assets/icons/defaultProductCard.png';
import receivedImg from '../assets/icons/received.png';
import invoiceTableEmptyImg from '../assets/icons/invoiceTableEmpty.png';
import addFormatImg from '../assets/icons/addFormat.png';
import papersImg from '../assets/icons/papers.png';
import analyticsImg from '../assets/icons/analytics.png';
import xeroImg from '../assets/icons/xero.png';
import stripePaymentImg from '../assets/icons/stripePayment.png';
import airwallexImg from '../assets/icons/airwallex.webp';
import stiggImg from '../assets/icons/stigg.png';
import emptyIntegrationImg from '../assets/icons/emptyIntegration.png';
import exitViewModeImg from '../assets/icons/exitViewMode.png';
import usdcImg from '../assets/icons/usdcToken.png';
import usdtImg from '../assets/icons/usdtToken.png';
import syncErrorImg from '../assets/icons/syncError.png';
import unitedStatesImg from '../assets/icons/United States.png';
import israelImg from '../assets/icons/Israel.png';
import unitedKingdomImg from '../assets/icons/United Kingdom.png';
import chinaImg from '../assets/icons/China.png';
import japanImg from '../assets/icons/Japan.png';
import euImg from '../assets/icons/eu.png';
import germanyImg from '../assets/icons/Germany.png';
import emptyIntegrationsImg from '../assets/icons/emptyIntegrations.png';
import saveChangesImg from '../assets/icons/saveChanges.png';
import hubspotImg from '../assets/icons/hubspot.png';
import syncingImg from '../assets/icons/syncing.png';
import subscriptionsImg from '../assets/icons/subscriptions.png';
import alertImg from '../assets/icons/alert.png';
import uploadLogoImg from '../assets/icons/uploadLogo.png';

export type ImagesOptionsType =
	| 'addCustomer'
	| 'modelNotFound'
	| 'addModel'
	| 'createCustomer'
	| 'addGroupType'
	| 'addProduct'
	| 'productCard'
	| 'greenPlanes'
	| 'codat'
	| 'modelsNotFound'
	| 'somethingWentWrong'
	| 'emptyGraph'
	| 'deleteItem'
	| 'createContract'
	| 'emptyData'
	| 'addModelBlue'
	| 'addContractBlue'
	| 'emptyGraphs'
	| 'wip'
	| 'addUsageReport'
	| 'success'
	| 'authorization'
	| 'noInternet'
	| 'noLateCustomers'
	| 'quickBooks'
	| 'whiteRefresh'
	| 'welcome'
	| 'salesforce'
	| 'emptyBox'
	| 'netsuite'
	| 'login'
	| 'received'
	| 'addFormat'
	| 'analytics'
	| 'papers'
	| 'xero'
	| 'stripePayment'
	| 'airwallex'
	| 'stigg'
	| 'emptyIntegration'
	| 'exitViewMode'
	| 'usdc'
	| 'usdt'
	| 'United States'
	| 'Israel'
	| 'United Kingdom'
	| 'China'
	| 'Japan'
	| 'Germany'
	| 'eu'
	| 'emptyIntegrations'
	| 'saveChanges'
	| 'alert'
	| 'uploadLogo';

export interface ImagesOptions {
	addCustomer: string;
	modelNotFound: string;
	addModel: string;
	createCustomer: string;
	addGroupType: string;
	addProduct: string;
	productCard: string;
	greenPlanes: string;
	modelsNotFound: string;
	codat: string;
	salesforce: string;
	somethingWentWrong: string;
	emptyGraph: string;
	deleteItem: string;
	createContract: string;
	emptyData: string;
	addModelBlue: string;
	addContractBlue: string;
	emptyGraphs: string;
	wip: string;
	addUsageReport: string;
	success: string;
	authorization: string;
	noInternet: string;
	noLateCustomers: string;
	activeContract: string;
	cantDelete: string;
	exportCSV: string;
	quickBooks: string;
	blankPricingModelCard: string;
	outOfSync: string;
	connected: string;
	whiteRefresh: string;
	welcome: string;
	emptyBox: string;
	netsuite: string;
	login: string;
	usageProductCard: string;
	defaultProductCard: string;
	received: string;
	invoiceTableEmpty: string;
	addFormat: string;
	analytics: string;
	papers: string;
	xero: string;
	stripePayment: string;
	airwallex: string;
	stigg: string;
	emptyIntegration: string;
	exitViewMode: string;
	usdc: string;
	usdt: string;
	syncError: string;
	'United States': string;
	Israel: string;
	'United Kingdom': string;
	China: string;
	Japan: string;
	eu: string;
	Germany: string;
	emptyIntegrations: string;
	saveChanges: string;
	hubspot: string;
	syncing: string;
	subscriptions: string;
	alert: string;
	uploadLogo: string;
}

export const images: ImagesOptions = {
	addCustomer: addCustomerImg,
	modelNotFound: modelsNotFoundImg,
	addModel: addModelImg,
	createCustomer: createCustomerImg,
	addGroupType: addGroupTypeImg,
	addProduct: addProductImg,
	productCard: productCardImg,
	greenPlanes: greenPlanesImg,
	modelsNotFound: modelsNotFoundImg,
	codat: codatImg,
	salesforce: salesforceImg,
	somethingWentWrong: somethingWentWrongImg,
	emptyGraph: emptyGraphImg,
	deleteItem: deleteItemImg,
	createContract: createContractImg,
	emptyData: emptyDataImg,
	addModelBlue: addModelBlueImg,
	addContractBlue: addContractBlueImg,
	emptyGraphs: emptyGraphsImg,
	wip: wipImg,
	addUsageReport: addUsageReportImg,
	success: successImg,
	authorization: authorizationImg,
	noInternet: noInternetImg,
	noLateCustomers: noLateCustomersImg,
	activeContract: activeContractImg,
	cantDelete: cantDeleteImg,
	exportCSV: exportCSVImg,
	quickBooks: quickBooksImg,
	blankPricingModelCard: blankPricingModelCardImg,
	outOfSync: outOfSyncImg,
	connected: connectedImg,
	whiteRefresh: whiteRefreshImg,
	welcome: welcomeImg,
	emptyBox: emptyBoxImg,
	netsuite: netsuiteImg,
	login: loginImg,
	usageProductCard: usageProductCardImg,
	defaultProductCard: defaultProductCardImg,
	received: receivedImg,
	invoiceTableEmpty: invoiceTableEmptyImg,
	addFormat: addFormatImg,
	papers: papersImg,
	analytics: analyticsImg,
	xero: xeroImg,
	stripePayment: stripePaymentImg,
	airwallex: airwallexImg,
	stigg: stiggImg,
	emptyIntegration: emptyIntegrationImg,
	exitViewMode: exitViewModeImg,
	usdc: usdcImg,
	usdt: usdtImg,
	syncError: syncErrorImg,
	'United States': unitedStatesImg,
	Israel: israelImg,
	'United Kingdom': unitedKingdomImg,
	China: chinaImg,
	Japan: japanImg,
	eu: euImg,
	Germany: germanyImg,
	emptyIntegrations: emptyIntegrationsImg,
	saveChanges: saveChangesImg,
	hubspot: hubspotImg,
	syncing: syncingImg,
	subscriptions: subscriptionsImg,
	alert: alertImg,
	uploadLogo: uploadLogoImg,
};
